import api from "../api.js";
import store from "@/store/index.js";

const GET_MALL_INFO = async (query, otherParams) => {
  // 这里替换为实际的API调用
  const response = await api.smCommon.GET_MALL_INFO({
    oper: "MALL_LIST",
    dsp_ca: 'SIM',
    qry_txt: query,
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  console.log(otherParams.showAll);
  if (otherParams.showAll && store.state.djsAdmin.mall_num > 1) {
    response.data.unshift({
      mall_id: store.state.djsAdmin.user_mall_list,
      mall_name: '全部门店'
    })
  }
  return response.data;
};
const fGetTableClsList = async query => {
  // 这里替换为实际的API调用
  const response = await api.smCommon.GET_DTABLE_CLS_INFO({
    oper: "CLS_LIST",
    mall_id: store.state.djsAdmin.mall_id
  });
  // 
  response.data.forEach((item, index) => {
    if (item.cls_id == '1001') {
      response.data.splice(index, 1)
    }
  })
  return response.data;
};
const GET_DTABLE_INFO = async (query, otherParams) => {
  // 这里替换为实际的API调用
  console.log(otherParams);
  const response = await api.smCommon.GET_DTABLE_INFO({
    oper: "DTABLE_LIST",
    cls_id_ex: otherParams.cls_id_ex || '1001',
    qry_txt: query,
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  return response.data;
};

const GET_VEN_INFO = async (query, otherParams) => {
  // 这里替换为实际的API调用
  console.log(otherParams);
  const response = await api.djsApi.fDjsQueryApi({
    methodName: 'GET_VEN_INFO',
    js: {
      OPER: "VEN_LIST",
      CLS_ID_EX: otherParams.cls_id_ex || '1001',
      MALL_ID: store.state.djsAdmin.mall_id,
      QRY_TXT: query,
      BUS_TYPE_ID: otherParams.bus_type_id || 'sipGx,sipLy',
      PAGE_SIZE: 50,
      NOW_PAGE: 1,
      FZY_YN: 'Y'
    }
  });
  return response.data;
};
const GET_USER_INFO = async query => {
  // 这里替换为实际的API调用
  const response = await api.smCommon.GET_USER_INFO({
    oper: "USER_LIST",
    qry_txt: query,
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  return response.data;
};
const GET_MALL_ACCT_INFO = async (query, otherParams) => {
  // 这里替换为实际的API调用
  console.log(otherParams);
  const response = await api.smCommon.GET_MALL_ACCT_INFO({
    oper: "ACCT_LIST",
    mall_id: otherParams.mall_id || store.state.djsAdmin.mall_id,
    qry_txt: query,
    amt_acct_id: otherParams.amt_acct_id || '',
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  return response.data;
};

const GET_REMARK_INFO = async (query, otherParams) => {
  // 这里替换为实际的API调用
  const response = await api.smCommon.GET_REMARK_INFO({
    oper: 'REMARK_LIST',
    remark_type_id: otherParams.remark_type || '',
    qry_txt: query,
    AMT_ACCT_ID: otherParams.amt_acct_id || '',
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  return response.data;
};


const GET_MALL_AMT_ACCT_INFO = async query => {
  // 这里替换为实际的API调用
  const response = await api.smCommon.GET_MALL_AMT_ACCT_INFO({
    oper: "AMT_ACCT_LIST",
    qry_txt: query,
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  return response.data;
};
const GET_VIP_INFO = async (query, otherParams) => {
  const response = await api.smCommon.GET_VIP_INFO({
    oper: "VIP_LIST",
    qry_txt: query,
    page_size: 10,
    now_page: 1,
    fzy_yn: 'Y',
    mall_id: otherParams.mall_id || store.state.djsAdmin.mall_id
  });
  // //剔除会员本身
  response.data.forEach((item, index) => {
    if (item.vip_id == otherParams.vipId) {
      response.data.splice(index, 1)
    }
  })
  return response.data;
};

const GET_MALL_FEE_INFO = async (query, otherParams) => {
  // 这里替换为实际的API调用
  const response = await api.smCommon.GET_MALL_FEE_INFO({
    oper: "FEE_LIST",
    mall_id: otherParams.mall_id || store.state.djsAdmin.mall_id,
    qry_txt: query,
    page_size: 50,
    now_page: 1,
    fzy_yn: 'Y'
  });
  return response.data;
}

export default {
  GET_MALL_INFO, //获取门店信息
  GET_DTABLE_INFO, //获取餐桌信息
  GET_USER_INFO, ///获取员工信息
  GET_MALL_ACCT_INFO, //获取门店账户信息
  GET_VIP_INFO, //获取会员信息
  fGetTableClsList, //获取桌台区域信息
  GET_VEN_INFO, //获取供应商信息
  GET_MALL_AMT_ACCT_INFO, //获取门店资金账户信息
  GET_REMARK_INFO, //获取备注信息
  GET_MALL_FEE_INFO, //获取门店手续费信息
};



//////////////////
// WEBPACK FOOTER
// ./common/global/listApi.js
// module id = null
// module chunks = 